<rask-toggle-panel class="mt-5" label="Checklista" [noPadding]="true">
    <ng-container header>
        ( {{numberOfSelectedFragor}} / {{checklisteFragor.length}} )
    </ng-container>

    <rask-header>{{headerText}}</rask-header>

    @if (grupperWithFragor.length > 0) {
        <rask-tabs [wrap]="true" [useRoute]="false" [autoSelectNewTab]="true">
            @for (grupp of grupperWithFragor; track $index) {
                <rask-tab [label]="grupp.gruppNamn" [icon]="getTabIcon(grupp)" [ignoreIconClick]="true">
                    <rask-kontrakt-checklist-grupp [grupp]="grupp"></rask-kontrakt-checklist-grupp>
                </rask-tab>
            }
        </rask-tabs>
    }
</rask-toggle-panel>